<template lang="pug">
section
  s-page-title(title='Менеджеры')
    template(slot='extension')
      v-btn(@click='onEdit()' color='primary' depressed) Добавить
  v-card
    s-data-filter(@search='debouncedSearch' :initial='dataFilter.search')
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      :total-items='total'
      :pagination='dataFilter'
      :rows-per-page-items='$config.rowsPerPageItems'
      @update:pagination='updatePagination'
    )
      template(slot='items' slot-scope='props')
        tr(class='with-pointer' @click='onEdit(props.item.id)')
          td(data-label='ID') {{ props.item.id }}
          td(data-label='Ава')
            template(v-if='props.item.avatar_url')
              v-avatar(color="grey lighten-4 mt-1 mb-1")
                img(:src="props.item.avatar_url")
          td(data-label='Менеджер') {{ props.item.full_name }}
          td(data-label='Телефон') {{ props.item.phone | phone }}
          td(data-label='Дата рождения') {{ props.item.birthday | date }}
          td(class='text-xs-right wrapless crud-tools')
            v-btn(icon @click.stop='onDelete(props.item.id)')
              v-icon(small) delete_outline
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'

export default {
  data: () => ({
    headers: [
      {
        text: '#ID',
        align: 'left',
        value: 'id',
        width: '0%'
      },
      {
        text: 'Ава',
        align: 'center',
        value: 'avatar_url',
        width: '10%'
      },
      {
        text: 'Менеджер',
        align: 'left',
        value: 'second_name',
        width: '33%'
      },
      {
        text: 'Телефон',
        align: 'left',
        value: 'phone',
        width: '33%'
      },
      {
        text: 'Дата рождения',
        align: 'left',
        value: 'birthday',
        width: '33%'
      },
      {
        text: '',
        align: 'left',
        width: '0%',
        sortable: false
      }
    ]
  }),

  methods: {
    updatePagination(pagination) {
      this.setDataFilter(pagination)
      this.fetch()
    },

    async onDelete(id) {
      if (await this.$confirm('Удалить менеджера?')) {
        try {
          await this.destroy({ id })
        } catch (e) {
          this.$root.showSnack('Ошибка удаления менеджера')
        }
        this.fetch()
      }
    },

    onEdit(id) {
      this.$router.push({
        name: 'Admin.Managers.Edit',
        params: { id }
      })
    },

    fetch() {
      this.fetchList({ config: { params: this.dataFilter } })
    },

    debouncedSearch: debounce(function(search) {
      this.setDataFilter({ search, page: 1 })
      this.fetch()
    }, 250),

    ...mapActions('admin/managers', ['fetchList', 'destroy']),
    ...mapMutations('admin/managers', ['setDataFilter'])
  },

  computed: {
    ...mapState('admin/managers', ['total', 'dataFilter']),
    ...mapGetters('admin/managers', ['list', 'isLoading'])
  }
}
</script>
